import { ReactNode, useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { TabGroupDto } from '@asset-metrix/portal-gateway-client-js';

import { getActiveContentGroupTabUrlSearchKey } from '../../../utils/contentTab';
import { SegmentedControl } from '../../segmentedControl/SegmentedControl';

import styles from './group.module.scss';

export function TabGroup({
  entity,
  children,
}: {
  entity: TabGroupDto;
  children: ReactNode;
}) {
  const [urlSearchParams, setUrlSearchParams] = useSearchParams();
  const activeTab =
    urlSearchParams.get(getActiveContentGroupTabUrlSearchKey(entity.id)) ??
    undefined;

  const updateUrlSearchParams = useCallback(
    (newValue: string) => {
      setUrlSearchParams((prev) => {
        prev.set(getActiveContentGroupTabUrlSearchKey(entity.id), newValue);
        return prev;
      });
    },
    [entity.id, setUrlSearchParams]
  );

  const initializeUrlSearchParams = useCallback(() => {
    if (
      activeTab == null ||
      !entity.tabs.some((tab) => tab.value === activeTab)
    ) {
      updateUrlSearchParams(entity.tabs[0].value);
    }
    // set first tab as active if entity (widget) id changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entity.id, entity.tabs, activeTab, updateUrlSearchParams]);

  useEffect(() => {
    initializeUrlSearchParams();
  }, [initializeUrlSearchParams]);

  return (
    <div className={`page-content__tab--group ${styles['tab-group']}`}>
      <SegmentedControl
        className={styles['tab-group__segmented-control']}
        value={activeTab}
        onChange={updateUrlSearchParams}
        options={entity.tabs}
      />
      {children}
    </div>
  );
}
